export enum StatusFilter {
  ACTIVATED = 'ACTIVATED',

  DISABLED = 'DISABLED',

  ALL = 'ALL',
}
